export default __webpack_public_path__ + "static/media/the-reporters.27afaa92.jpg";